//import React, { useContext } from 'react';
import { PageHeader, Page, PageContent, Box, Text, Image } from 'grommet';
//import Iframe from 'react-iframe';

export const RoadmapDisplay = () => {
  //const [user, setUser] = useState(defaultUser);
  //const size = useContext(ResponsiveContext);

  return (
    <Page flex="grow" background="background">

      <Box background="url('/images/home-banner.png')" height="200px" margin={{ top: 'none'}}>
        <Box margin={{ top: 'none', left: 'large' }}>
          <PageHeader pad={{ top: '15px', bottom: '15px' }} 
                      title={<Text color="black" size="xxlarge" weight="bolder" style={{fontWeight: 'bold'}}>HPE Roadmap Display</Text>} 
                      subtitle={<Text color="black" size="xxlarge">Route to Market</Text>}
                      style={{ color: 'black' }}/>
        </Box>                  
      </Box> 

      <PageContent flex="grow">
          <Box pad={{ top: '15px' }}>
          <Text weight="bold">Note: indicative placeholder graphic (Aha) for initial concept notion. Need to define and lock drill downs as key discussion item and wire in live view(s).</Text>
          </Box>

          <Box direction="row" width="100%" pad={{ top: '35px' }} flex="grow">
            <Image fit="cover" src="images/example-features-roadmap-v2.png"/>
          </Box>

      </PageContent>  

    </Page>
  );
};